import { onlineManager, QueryClient } from '@tanstack/react-query'

import { isOnlineNow, subscribeToOnlineStatus } from './offline/connectivity'

export function followServerReachability() {
  onlineManager.setEventListener(setOnline => {
    setOnline(isOnlineNow())
    return subscribeToOnlineStatus(() => setOnline(isOnlineNow()))
  })
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 1000 * 60 * 60 * 24,
      networkMode: 'offlineFirst',
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
})
